import type { SxProps } from "@mui/material";

import { SectionDivider } from "@app/analytics/components/reports/styles";
import EditableReportSubSection from "@app/analytics/MeetingReport/components/EditableReportSubSection";
import { EDITING_TOOLTIP } from "@app/analytics/MeetingReport/constants";
import useSessionMetadata from "@app/analytics/MeetingReport/hooks/useSessionMetadata";
import useEditStore from "@app/analytics/MeetingReport/stores/edits";
import EmptyTranscript from "@app/analytics/MeetingReport/Transcript/EmptyTranscript";
import useFeatureAccess from "@app/common/hooks/useFeatureAccess";

import MeetingReportRecapTranscript from "./MeetingReportRecapTranscript";

const RecapTranscriptSection = ({
  sx,
  asTab = false,
}: {
  sx?: SxProps;
  asTab?: boolean;
}) => {
  const { canAccessTranscript } = useFeatureAccess();
  const inEditMode = useEditStore((state) => state.editingSection != null);

  const {
    data: { isNotetakerReport },
  } = useSessionMetadata();

  if (isNotetakerReport) return null;

  // hide the divider in edit mode since it causes an awkward-looking
  // 1px gap between overlays
  const showDivider = !asTab && !inEditMode;

  return (
    <>
      {showDivider && <SectionDivider />}
      <EditableReportSubSection
        id="transcript"
        disabledTooltip={EDITING_TOOLTIP.editingNotes}
        sx={sx}
      >
        {canAccessTranscript ? (
          <MeetingReportRecapTranscript />
        ) : (
          <EmptyTranscript type="unauthorized" />
        )}
      </EditableReportSubSection>
    </>
  );
};

export default RecapTranscriptSection;
